import styled from 'styled-components';
import images from 'rc-images';
import { googleApiKey } from '../../../app/apis';

const createStaticMap = (lat, lng) => `http://maps.google.com/maps/api/staticmap?center=${lat},${lng}&zoom=13&size=400x150&sensor=false&key=${googleApiKey}`;

const StaticMap = styled.button`
  background: url(${images.icons.marker}) center 5px no-repeat ,url(${({ lat, lng }) => createStaticMap(lat, lng)});
  height: 110px;
  width: 100%;
  cursor: pointer;
  border: none !important;
  background-color: transparent !important;
  
`;

export default StaticMap;
